import { Suspense, memo } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ScrollProgress from "@/components/ScrollProgress";
import LoadingScreen from "@/components/LoadingScreen";
import { useSmoothScroll } from "@/hooks/use-smooth-scroll";
import { lazyWithReload } from "@/lib/lazyWithReload";

// Lazy load below-the-fold components and recover from stale deploy caches.
const Shows = lazyWithReload(() => import("@/components/Shows"));
const About = lazyWithReload(() => import("@/components/About"));
const Gallery = lazyWithReload(() => import("@/components/Gallery"));
const MyTickets = lazyWithReload(() => import("@/components/MyTickets"));
const Contact = lazyWithReload(() => import("@/components/Contact"));
const Footer = lazyWithReload(() => import("@/components/Footer"));
const PaymentStatus = lazyWithReload(() => import("@/components/PaymentStatus"));
const ScrollToTop = lazyWithReload(() => import("@/components/ScrollToTop"));
const CookieConsent = lazyWithReload(() => import("@/components/CookieConsent"));
const GoogleAnalytics = lazyWithReload(() => import("@/components/GoogleAnalytics"));
const StickyTicketBar = lazyWithReload(() => import("@/components/StickyTicketBar"));

const Index = memo(() => {
  // Enable smooth scrolling with navbar offset
  useSmoothScroll({ offset: 80 });

  return (
    <main className="min-h-screen w-full bg-background overflow-x-hidden relative">
      <ScrollProgress />
      <LoadingScreen />
      <Navbar />
      <Hero />
      
      <Suspense fallback={null}>
        <Shows />
        <About />
        <Gallery />
        <MyTickets />
        <Contact />
        <Footer />
        <PaymentStatus />
        <ScrollToTop />
        <CookieConsent />
        <GoogleAnalytics />
        <StickyTicketBar />
      </Suspense>
    </main>
  );
});

Index.displayName = 'Index';

export default Index;
